
import 'whatwg-fetch'
import Cookies from 'js-cookie'

const overrideFetch = function(url, options, disableReload) {
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    ...options
  }).then(response => {
    if(!response.ok && response.status === 401 && !disableReload) {
      Cookies.remove('axinan-jwt', { domain: '.axinan.com' })
      window.location.reload(false)
    }
    return response
  })
}

export default overrideFetch



// WEBPACK FOOTER //
// ./src/utils/fetch.js